import {
  inviteResidentToPortal,
  removeResidentPortalAccess,
  type ResidentListOut,
} from '@myrentalmate/api-client';

import { okData } from '../../lib/apiData';
import { PortalAccess as Access } from '../records/PortalAccess';

/** Giving a resident their portal login, or taking it away. */
export function PortalAccess({ resident }: { resident: ResidentListOut }) {
  return (
    <Access
      title="Resident Portal"
      joinedText={'They can sign in to see their balance, payments and the files you share.'}
      inviteText={
        'Invite them to see their balance, payments and the files you share. The invitation goes to the email on this record.'
      }
      joined={resident.user_id !== null}
      invite={async () => okData(await inviteResidentToPortal(resident.id))?.invite_url}
      remove={() => removeResidentPortalAccess(resident.id)}
    />
  );
}
